<template>
    <div v-if="visible" class="container">
        <ReportWorkButton @newReport="addReport" @finishedReport="finishReport"/>
        <div class="row mt-3">
            <div class="col-md-12 col-lg-3">               
                <div class="box-bordered o-f-h p-10 m-b-30">
                    <AddReport @created="fetchData">
                    </AddReport>
                </div>               
            </div>
            <div class="col-md-12 col-lg-9">
                <div class="box-bordered p-10">
                    <form @submit.prevent="fetchData">                
                        <div class="row">
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <vs-tooltip text="Data początkowa">
                                            <span class="input-group-text"><i class="material-icons">today</i></span>
                                        </vs-tooltip>
                                    </div>
                                    <input class="form-control" type="date" id="form-date-from" v-model="dateFrom"
                                           max="9999-12-31" required/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="input-group mb-3">                      
                                    <div class="input-group-prepend">
                                        <vs-tooltip text="Data końcowa">
                                            <span class="input-group-text"><i class="material-icons">event</i></span>
                                        </vs-tooltip>
                                    </div>
                                    <input class="form-control" type="date" id="form-date-to" v-model="dateTo"
                                           max="9999-12-31" required/>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <vs-tooltip text="Łączny przepracowany czas w podanym przedziale dat">
                                            <span class="input-group-text"><i class="material-icons">history</i></span>
                                        </vs-tooltip>
                                    </div>
                                    <div class="form-control">
                                        {{ elapsedTime }}
                                    </div>
                                </div>
                            </div>
                            <button type="submit" ref="submitButton" style="display: none"></button>
                        </div>
                    </form>
                    <div v-if="data.results">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col">Dzień</th>
                                <th scope="col">Początek</th>
                                <th scope="col">Koniec</th>
                                <th scope="col">Czas</th>
                                <th scope="col">Miejsce</th>
                                <th style="width: 30px;"></th>
                            <tr/>
                            </thead>
                            <transition-group name="report-list" tag="tbody">
                                <template v-if="data.results.length">
                                    <tr v-for="(report,idx) in data.results"
                                        class="report-list-item"
                                        :key="report.id"
                                        :style="{'background-color': getStyle(report)}"
                                        @mouseover="whereDeleteButton = idx"
                                        @mouseleave="whereDeleteButton = -1">
                                        <template v-if="report.id === 'empty'">
                                            <td colspan="6"><br/></td>
                                        </template>
                                        <template v-else>
                                            <td>{{ formatDate(report.on_date) }}</td>
                                            <td>{{ minutesToTime(report.from_hour) }}</td>
                                            <td>{{ minutesToTime(report.to_hour) }}</td>
                                            <td>{{ periodOfTime(report.from_hour, report.to_hour) }}</td>
                                            <td>{{ getPlace(report.place) }}</td>
                                            <td>
                                                <button :style="{ visibility: idx === whereDeleteButton ? 'visible' : 'hidden' }"
                                                        type="button" class="close" aria-label="Close" data-toggle="modal"
                                                        :data-target="'#delete-report-button-' + report.id">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>

                                                <ConfirmCancelReservation :id="'delete-report-button-' + report.id"
                                                                        @yes="deleteReport(report.id)" @no="() => {}">
                                                    <h6 slot="body">
                                                        Czy na pewno chcesz usunąć raport od {{ minutesToTime(report.from_hour) }}
                                                        do {{ minutesToTime(report.to_hour) }}
                                                        z dnia {{ formatDate(report.on_date) }}?
                                                    </h6>
                                                </ConfirmCancelReservation>
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                                <tr v-else class="table-secondary" :key="'no-data'">
                                    <td colspan="6">Brak danych</td>
                                </tr>
                            </transition-group>
                        </table>
                        <vs-pagination
                                    v-if="showPagination"
                                    :max="pagination_max"
                                    :total="data.pages"
                                    v-model="currentPage"
                                    :ref="'pagination'">
                        </vs-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {backend} from "../../backend.js";
    import axios from "axios";
    import Constants from "../../constants.js"
    import ReportWorkButton from "./ReportWorkButton.vue";
    import AddReport from "./AddReport.vue";
    import ConfirmCancelReservation from "../PopUp.vue"

    const PLACE_COLOR = Constants.get('IA_PLACE_COLOR');
    const activeReportColor = "rgba(232, 255, 223, 0.75)";
    const forgottenReportColor = "#ff6161";

    moment.locale('pl');

    export default {
        name: "ReportHistoryView",
        components: {ReportWorkButton, AddReport, ConfirmCancelReservation},
        data() {
            return {
                data: {},
                dateFrom: moment().startOf('month').format('YYYY-MM-DD'),
                dateTo: moment().format('YYYY-MM-DD'),
                places: [],
                pagination_max: 8,
                currentPage: 1,
                visible: false,
                showPagination: false,
                whereDeleteButton: -1,
            }
        },
        computed: {
            elapsedTime() {
                let hours = Math.floor(this.data.sum / 60);
                let minutes = (this.data.sum % 60);
                if (hours > 0) {
                    return hours + ' h ' + minutes + ' min';
                } else {
                    return minutes + ' min';
                }
            },
        },
        watch: {
            dateTo() {
                this.$refs['submitButton'].click();
            },
            dateFrom() {
                this.$refs['submitButton'].click();
            },
            currentPage() {
                this.fetchData(this.currentPage);
            }
        },
        updated() {
            this.showPagination = this.data.pages > 1; // vuesax do not reload vs-pagination properly, so
                                                       // after deleting it through v-if we add it here if necessary
        },
        methods: {
            getStyle(report) {
                if (report.to_hour !== -1) {
                    return PLACE_COLOR[report.place];
                }
                else if (moment(report.on_date) < moment().startOf('day')) {
                    return forgottenReportColor;
                }
                else {
                    return activeReportColor;
                }
            },
            getPlace: function (place_id) {
                let place = this.places.find(obj => obj.id === place_id);
                if (place)
                    return place.name;
                return `${place_id} (nie ma miejsca o takim id)`;
            },
            formatDate: function (date) {
                return moment(date).format('DD.MM.YYYY');
            },
            minutesToTime: function (mins) {
                if (mins === -1)
                    return '---';
                return moment.utc().startOf('day').add(mins, 'minutes').format('HH:mm');
            },
            periodOfTime: function (from_hour, to_hour) {
                if (to_hour === -1)
                    return '---';
                let duration = moment.duration(to_hour - from_hour, 'minutes');
                return duration.hours() + ':' + duration.minutes().toString().padStart(2, '0');
            },
            deleteReport: function(reportId) {
                backend.deleteReport(reportId)
                    .then(() => {
                        let noFinished = this.data.results.reduce((acc, val) => acc + (val.to_hour >= 0), 0);
                        if (noFinished === 1 && this.currentPage > 1) {
                            this.fetchData(this.currentPage - 1);
                        }
                        else {
                            this.data.results.splice(this.data.results.findIndex(e => e.id === reportId), 1);
                            this.data.results.push({id: 'empty'});
                            this.fetchData(this.currentPage);
                        }
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się usunąć raportu.', color: 'danger'});
                    });
            },
            fetchData: function (page = 1) {
                if (typeof page === 'object') {
                    page = 1;
                }
                this.currentPage = page;
                let toDate = moment(this.dateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                return backend.getReports({
                    from_date: this.dateFrom, to_date: toDate, user: this.$store.getters['auth/remoteUser'],
                    page: page, ordering: '-on_date_date,-from_hour', sum: "true", 'min_to_hour': 0, 'active_first': true
                })
                    .then((response) => {
                        if (this.data.pages !== response.data.pages) {
                            this.showPagination = false; // vuesax do not refresh number of pages in vs-pagination, so
                                                         // we have to delete pagination component and add it back in updated
                        }
                        this.data = response.data;
                        let pagination = this.$refs['pagination'];
                        if (pagination !== undefined) {
                            pagination._data.current = page; // set first page manually;
                        }
                        if (this.data.results && this.data.results.length > 0 && this.data.results[0].to_hour === -1) {
                            this.$store.dispatch('ia/setCurrentReport', this.data.results[0]);
                        }
                        else {
                            this.$store.dispatch('ia/setCurrentReport', null);
                        }
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy raportów.', color: 'danger'});
                    });
            },
            previous: function () {
                axios.get(this.data.previous)
                    .then((response) => {
                        this.data = response.data;
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy raportów.', color: 'danger'})
                    });
            },
            next: function () {
                axios.get(this.data.next)
                    .then((response) => {
                        this.data = response.data;
                    })
                    .catch(() => {
                        this.$vs.notify({text: 'Nie udało się pobrać listy raportów.', color: 'danger'})
                    });
            },
            addReport(report) {
                this.data.results.unshift(report);
                this.$store.dispatch('ia/setCurrentReport', report);
            },
            finishReport(report) {
                this.$set(this.data.results, 0, report);
                this.fetchData();
            },
        },
        mounted() {
            let placesPromise = this.$store.dispatch('ia/places', true)
                .then((data) => {
                    this.places = data;
                })
                .catch(() => {
                    this.$vs.notify({text: 'Nie udało się pobrać listy miejsc.', color: 'danger'})
                });
            let dataPromise = this.fetchData();
            Promise.all([placesPromise, dataPromise])
                .then(() => {
                    this.visible = true;
                });
        }
    }
</script>

<style scoped>
    .report-list-item {
        transition: all .5s;
    }

    .report-list-enter, .report-list-leave-to {
        opacity: 0;
    }

    .report-list-leave-active {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// ReportHistoryView.vue?0b627724